"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticFileType = void 0;
var DiagnosticFileType;
(function (DiagnosticFileType) {
    DiagnosticFileType[DiagnosticFileType["SeccLog"] = 1] = "SeccLog";
    DiagnosticFileType[DiagnosticFileType["Screenshot"] = 2] = "Screenshot";
    DiagnosticFileType[DiagnosticFileType["KernelLog"] = 3] = "KernelLog";
    DiagnosticFileType[DiagnosticFileType["Pcap"] = 4] = "Pcap";
})(DiagnosticFileType = exports.DiagnosticFileType || (exports.DiagnosticFileType = {}));
